import { action, observable, runInAction } from 'mobx';

import notificationsClient from '../clients/NotificationsClient';
import { captureException } from '../sentry/index';

import { ApiStore } from './base/apiStore';

export default class NotificationsStore extends ApiStore {
  @observable unseenCount: number = 0;

  @action
  acknowledgeUnseenNotificationsCount() {
    this.unseenCount = 0;
  }

  countUnseenNotifications() {
    (async () => {
      try {
        const { count } = await notificationsClient.countUnseenNotifications();
        runInAction(() => {
          this.unseenCount = count;
        });
      } catch (e) {
        captureException(e);
      }
    })();
  }
}
